import React from 'react'
import { ImageAnswerModel } from '../../../../model/knowledge.model'
import './ImageAnswer.css'
import ReuploadButton from './ReuploadButton'
interface VideoAnswerProps {
    answer: string
    isLocked?: boolean
    onReupload?: (answer: string) => void
}
const VideoAnswer = (props: VideoAnswerProps) => {
    let answer: ImageAnswerModel = { ResourceUrl: '' }
    try {
        answer = JSON.parse(props.answer)
    } catch (error) {
        console.error(error)
    }
    return (
        <div className='answer-image-item'>
            <video controls preload='metadata' className='answer-video'>
                <source src={answer.SourceUrl} type='video/mp4' />
            </video>
            {!props.isLocked && (
                <ReuploadButton
                    lt={20}
                    onResolve={(src, name) => {
                        const videoAnswer: ImageAnswerModel = {
                            ResourceUrl: src,
                            Thumb: '',
                            Title: name,
                            SourceUrl: src,
                        }
                        props.onReupload &&
                            props.onReupload(JSON.stringify(videoAnswer))
                    }}
                />
            )}
        </div>
    )
}

export default VideoAnswer
